import "@/App.css";
import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { UserLayout } from "./components/UserLayout";
import { AdminLayout } from "./components/AdminLayout";

import Login from "./pages/Login";
import Dashboard from "./pages/user/Dashboard";
import Deposit from "./pages/user/Deposit";
import Withdrawal from "./pages/user/Withdrawal";
import History from "./pages/user/History";
import Profile from "./pages/user/Profile";

import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminUsers from "./pages/admin/AdminUsers";
import AdminUserDetail from "./pages/admin/AdminUserDetail";
import AdminDeposits from "./pages/admin/AdminDeposits";
import AdminWithdrawals from "./pages/admin/AdminWithdrawals";
import AdminTransactions from "./pages/admin/AdminTransactions";
import AdminSettings from "./pages/admin/AdminSettings";

const Loader = () => (
  <div className="min-h-screen flex items-center justify-center bg-background">
    <div className="font-heading text-xl tracking-tight animate-pulse">Swiftors<span className="text-[#059669]">.</span></div>
  </div>
);

const UserRoute = ({ children }) => {
  const { user, checked } = useAuth();
  if (!checked || user === null) return <Loader />;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role === "admin") return <Navigate to="/admin" replace />;
  return <UserLayout>{children}</UserLayout>;
};

const AdminRoute = ({ children }) => {
  const { user, checked } = useAuth();
  if (!checked || user === null) return <Loader />;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== "admin") return <Navigate to="/" replace />;
  return <AdminLayout>{children}</AdminLayout>;
};

function App() {
  return (
    <div className="App">
      <Toaster position="top-right" richColors />
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />

            <Route path="/" element={<UserRoute><Dashboard /></UserRoute>} />
            <Route path="/deposit" element={<UserRoute><Deposit /></UserRoute>} />
            <Route path="/withdrawal" element={<UserRoute><Withdrawal /></UserRoute>} />
            <Route path="/history" element={<UserRoute><History /></UserRoute>} />
            <Route path="/profile" element={<UserRoute><Profile /></UserRoute>} />

            <Route path="/admin" element={<AdminRoute><AdminDashboard /></AdminRoute>} />
            <Route path="/admin/users" element={<AdminRoute><AdminUsers /></AdminRoute>} />
            <Route path="/admin/users/:id" element={<AdminRoute><AdminUserDetail /></AdminRoute>} />
            <Route path="/admin/deposits" element={<AdminRoute><AdminDeposits /></AdminRoute>} />
            <Route path="/admin/withdrawals" element={<AdminRoute><AdminWithdrawals /></AdminRoute>} />
            <Route path="/admin/transactions" element={<AdminRoute><AdminTransactions /></AdminRoute>} />
            <Route path="/admin/settings" element={<AdminRoute><AdminSettings /></AdminRoute>} />

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
